import React from 'react'

export const UserListContext = React.createContext<() => void>(() => {})
